import React, { useEffect } from 'react';
import NiceModal from "@ebay/nice-modal-react"
import { useRouter } from 'next/router';
import Head from 'next/head';
import Gamepads from '@components/Gamepad';
import Dashboard from '@components/Dashboard';
import { safeLocalStorage } from '@utils/localstorage';

const App = () => {
	const router = useRouter();
	const token = safeLocalStorage.getItem('token');
	const openWorldGame = safeLocalStorage.getItem('openWorldGame');

	useEffect(() => {
		if (!token) {
			router.push('/');
			return;
		}
		if (token?.user?.blocklisted) {
			router.push('/banned');
			return;
		}

		const shouldUseDashboard = Boolean(openWorldGame || token.user.has_test_drive);
		if (openWorldGame) {
			safeLocalStorage.removeItem('openWorldGame');
		}

		if (!shouldUseDashboard) {
			router.push('/testdrive');
			return;
		}

		// Only navigate when coming from another route — not when already on /dashboard.
		if (router.pathname !== '/dashboard') {
			router.push('/dashboard');
		}
	}, [token, openWorldGame, router]);

	if (!token || token?.user?.blocklisted) {
		return <></>;
	}

	return (
		<>
			<Head>
				<title>Dashboard</title>
			</Head>
			<Gamepads>
				<Dashboard />
			</Gamepads>
		</>
	);
};

export default App;
